import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Note mdxType="Note">
      <p>{`Only `}<a parentName="p" {...{
          "href": "/graphos/org/members#organization-wide-member-roles"
        }}>{`GraphOS org admins`}</a>{` can configure SSO.
Check the `}<strong parentName="p">{`Members`}</strong>{` tab in `}<a parentName="p" {...{
          "href": "https://studio.apollographql.com/"
        }}>{`GraphOS Studio`}</a>{` to see your role and which team members are org admins.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      